
import { Component, HostListener, OnInit, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { BotPreviewService } from 'src/app/shared/services/bot-preview.service';
import { DebugViewComponent } from './debug-view.component';

@Component({
    selector: 'app-debug-split-view',
    standalone: true,
    imports: [DebugViewComponent],
    templateUrl: './debug-split-view.component.html',
    styleUrls: ['./debug-split-view.component.scss']
})
export class DebugSplitViewComponent implements OnInit {
    // Signal-backed, weil nach await gesetzt (zoneless).
    private readonly _sanitizedPreviewUrl = signal<SafeResourceUrl>('');
    public get sanitizedPreviewUrl(): SafeResourceUrl { return this._sanitizedPreviewUrl(); }
    public set sanitizedPreviewUrl(value: SafeResourceUrl) { this._sanitizedPreviewUrl.set(value); }
    public botId = '';
    public leftWidthPercent = 60;
    public isDragging = false;

    private dragStartX = 0;
    private dragStartWidth = 0;
    private containerWidth = 0;

    constructor(
        private route: ActivatedRoute,
        private sanitizer: DomSanitizer,
        private botPreview: BotPreviewService
    ) { }

    public async ngOnInit(): Promise<void> {
        this.botId = this.route.snapshot.params['id'] as string;
        const rawUrl = this.route.snapshot.queryParams['previewUrl'] as string | undefined;
        // Only same-app paths like /de/bot/<id>/chat; anything else (javascript:, //host) would be trusted blindly.
        if (rawUrl && /^\/[a-z]{2}(-[a-z]{2})?\/(bot|fusion)\//i.test(rawUrl)) {
            this.sanitizedPreviewUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                await this.botPreview.previewUrl(this.botId, rawUrl)
            );
        }
    }

    public startDrag(event: MouseEvent, container: HTMLElement): void {
        this.isDragging = true;
        this.dragStartX = event.clientX;
        this.dragStartWidth = this.leftWidthPercent;
        this.containerWidth = container.offsetWidth;
        event.preventDefault();
    }

    @HostListener('document:mousemove', ['$event'])
    public onMouseMove(event: MouseEvent): void {
        if (!this.isDragging) return;
        const deltaX = event.clientX - this.dragStartX;
        const deltaPercent = (deltaX / this.containerWidth) * 100;
        this.leftWidthPercent = Math.min(85, Math.max(15, this.dragStartWidth + deltaPercent));
    }

    @HostListener('document:mouseup')
    public onMouseUp(): void {
        this.isDragging = false;
    }
}
